module.exports = __webpack_public_path__ + "img/androidvelvet.cf73d60d.png";